import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstEstadistica = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_estadistica', 
        name: 'Listado De Estadística', 
        component: ViewLstEstadistica,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
